
import './App.css';
import React, {Fragment, useState} from 'react';
import Login from './components/Login';
import { useSelector } from 'react-redux';
import Home from  './components/Home';
import Redir from './components/Redir';
import useToken from './components/useToken';


import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { loginData } from './features/login';

function App() {

  const { token, setToken } = useToken();


  if(token == -1 || 
    token === null || 
    token == 'undefined' || 
    token == undefined ||
    token == '-1' ) {
    console.log("token not set");
    return  <Login setToken={setToken}/>;
  }
  return (
   
      <Router>
          <Routes>
            <Route exact path='/' element={<Home/>}/>
            <Route exact path='/redir' element={<Redir/>}/>
            <Route exact path='/login' element={<Login setToken={setToken}/>}/>
          </Routes>
      </Router>

  );
}

export default App;
